module.exports = __webpack_public_path__ + "static/odd-fellows-e36a4c76e9021668ce0570f14b945257.png";